import VueI18n, { DateTimeFormats } from "vue-i18n"
import { clientApi } from "store/api"
import { AxiosError } from "axios"

require("../initializers/i18n.js")

const recheckNow = function (store) {
  const ts_key = `suus_i18n_de_timestamp`
  const last_checked_at_val = store.getItem(ts_key)

  if (!last_checked_at_val) {
    return true
  }

  const last_checked_at = Number.parseInt(last_checked_at_val)
  const delayInMin = (min) => 1000 * 60 * min

  const mins = process.env.NODE_ENV == "development" ? 1 : 10

  const recheckNow = last_checked_at + delayInMin(mins) < Date.now()

  // console.log(`Recheck in ${(last_checked_at + delayInMin(mins) - Date.now()) / 1000} sec`)

  return recheckNow
}

let i18nLoading = false
const loadI18n = async function (i18n, store) {
  if (i18nLoading) return
  i18nLoading = true
  try {
    const { data: messages } = await clientApi.getLocales()

    store.setItem(`suus_i18n_de_timestamp`, Date.now())
    i18n.setLocaleMessage(i18n.locale, messages)
    store.setItem(`suus_i18n_de`, JSON.stringify(messages))
  } catch (ex) {
    if ((ex as any).isAxiosError && (ex as AxiosError).code === "ERR_NETWORK") {
      console.warn(
        "Could not load locales, probably the backend is not running."
      )
    } else {
      throw ex
    }
  } finally {
    i18nLoading = true
  }
}

const restoreI18n = function (i18n, store) {
  //console.info("restoring i18n.")
  const messagesStr = store.getItem(`suus_i18n_de`)

  if (messagesStr) {
    const messages = JSON.parse(messagesStr)
    i18n.setLocaleMessage("de", messages)
    if (i18n.locale !== "de") i18n.locale = "de"
    //console.info("I18n restored.")
  } else {
    loadI18n(i18n, store)
  }
}

const initI18n = function (i18n, store) {
  restoreI18n(i18n, store)
  if (recheckNow(store)) loadI18n(i18n, store)
}

const dateTimeFormats: DateTimeFormats = {
  de: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    },
  },
}

export const i18n = new VueI18n({
  locale: "de",
  dateTimeFormats,
  missing: function (locale, key, vm) {
    if (recheckNow(window.localStorage)) {
      console.log("I18n key '" + key + "' missing, reloading locales.")
      loadI18n(i18n, window.localStorage)
    }
  },
})

initI18n(i18n, window.localStorage)
